export const GET_DATA_PROJECT_ADVANCE = 'GET_DATA_PROJECT_ADVANCE';
export const DATA_PROJECT_ADVANCE_IN_SEARCH = 'DATA_PROJECT_ADVANCE_IN_SEARCH';
